<template>
  <div class="p_employee_content">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>系统</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/departMember' }">组织架构</el-breadcrumb-item>
          <el-breadcrumb-item>{{
            isEdit == "true" ? "编辑员工" : "新增员工"
          }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="p_employee_box" v-loading="tableLoading">
        <p class="r_edit_title">基础信息</p>
        <el-form :model="ruleForm" :rules="emprules1" ref="empForm1" label-width="90px" class="p_employee_form">
          <el-form-item label="关联主账号" class="p_employee_top">
            <!-- <div class="emp_form"> -->
            <el-select filterable :disabled="isEdit == 'true'" size="small" @change="mainChange" v-model="ruleForm.userInfo.mainuserid" clearable placeholder="">
              <el-option v-for="(item, index) in userList" :key="index + 'p'" :label="item.Username" :value="item.Userid"></el-option>
            </el-select>
            <!-- </div> -->
          </el-form-item>
          <el-form-item label="员工姓名" prop="userInfo.userName">
            <el-input v-model.trim="ruleForm.userInfo.userName" size="small" :disabled="
                !isNull(ruleForm.userInfo.mainuserid) || isEdit == 'true'
              " placeholder="" clearable></el-input>
          </el-form-item>
          <el-form-item label="手机号码" prop="userInfo.userTel">
            <el-input v-model.trim="ruleForm.userInfo.userTel" size="small" @input="changePhone" placeholder="" clearable></el-input>
          </el-form-item>
          <el-form-item label="身份证" prop="userInfo.stridcard">
            <el-input v-model.trim="ruleForm.userInfo.stridcard" size="small" :disabled="
                !isNull(ruleForm.userInfo.mainuserid) || isEdit == 'true'
              " placeholder="" clearable></el-input>
          </el-form-item>
          <el-form-item label="员工区分" prop="userInfo.struserdist">
            <el-select @change="distChange" v-model="ruleForm.userInfo.struserdist" size="small" :disabled="
                !isNull(ruleForm.userInfo.mainuserid)
              " clearable placeholder="">
              <el-option v-for="(item, index) in typeList" :key="index + 'b'" :label="item.name" :value="item.name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="员工类型">
            <el-select size="small" :disabled="!isNull(ruleForm.userInfo.mainuserid)" v-model="ruleForm.userInfo.userlabelid" clearable @change="typeChange" placeholder="">
              <el-option v-for="(item, index) in baseInfoList" :key="index + 'k'" :label="item.Name" :value="item.Id + ''"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="入职时间" prop="userInfo.dtEntryDate">
            <el-date-picker clearable :disabled="!isNull(ruleForm.userInfo.mainuserid)" size="small" v-model="ruleForm.userInfo.dtEntryDate" type="date" value-format="yyyy-MM-dd" placeholder="">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="招聘电话" prop="userInfo.appleTel">
            <el-input v-model.trim="ruleForm.userInfo.appleTel" size="small" placeholder="" clearable></el-input>
          </el-form-item>
        </el-form>
        <p class="r_edit_title">部门信息</p>
        <el-form :model="ruleForm" :rules="emprules2" ref="empForm2" label-width="90px" class="p_employee_form">
          <el-form-item label="所属部门" prop="userInfo.organcodeVal">
            <el-cascader :options="departmentList" size="small" ref="cascader" @change="departChange" v-model="ruleForm.userInfo.organcodeVal" :props="{
                checkStrictly: true,
                value: 'strorgancode',
                label: 'strorganname',
              }" filterable clearable :show-all-levels="false"></el-cascader>
          </el-form-item>
          <el-form-item label="岗位" prop="userInfo.Strstation">
            <el-select @change="stationChange" v-model="ruleForm.userInfo.Strstation" size="small" clearable placeholder="">
              <el-option v-for="(item, index) in stationList" :key="index + 'a'" :label="item.StationName" :value="item.Stationid"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否合伙人">
            <el-select v-model="ruleForm.userInfo.StrIspartner" size="small" placeholder="">
              <el-option value="是"></el-option>
              <el-option value="否"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="职级">
            <el-select v-model="ruleForm.userInfo.StrRank" size="small" clearable placeholder="">
              <el-option v-for="(item, index) in rankList" :key="index + 'b'" :label="item.Name" :value="item.Name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="安全级别">
            <el-select size="small" v-model="ruleForm.userInfo.StrSecLevel" clearable placeholder="">
              <el-option v-for="(item, index) in securityList" :key="index + 'k'" :label="item.Name" :value="item.Name"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="上级主管" prop="userInfo.strtopuserid">
            <el-select filterable size="small" v-model="ruleForm.userInfo.strtopuserid" clearable placeholder="">
              <el-option v-for="(item, index) in userList" :key="index + 'h'" :label="item.Username" :value="item.Userid"></el-option>
            </el-select>
          </el-form-item>
          <div class="p_employee_form p_employee_form01" v-for="(item, index) in ruleForm.postList" :key="index + 'p'">
            <el-form-item label="工作岗位" :prop="'postList.' + index + '.strWorkJob'">
              <el-input v-model.trim="item.strWorkJob" size="small" placeholder="" clearable></el-input>
            </el-form-item>
            <el-form-item label="职能标签">
              <el-select v-model="item.strJobfunclabel" size="small" clearable placeholder="">
                <el-option v-for="(item, index) in jobFunList" :key="index + 'e'" :label="item.strParametername" :value="item.strParameterid"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="上级主管" :prop="'postList.' + index + '.strtopuserid'">
              <el-select filterable v-model="item.strtopuserid" size="small" clearable placeholder="">
                <el-option v-for="(item, index) in userList" :key="index + 'w'" :label="item.Username" :value="item.Userid"></el-option>
              </el-select>
            </el-form-item>
            <!-- :prop="'ruleForm.postList'+index+'.strTimepro'" { required: true, message: '请输入时间占比', trigger: 'blur' }, -->
            <el-form-item label="时间占比" :prop="'postList.' + index + '.strTimepro'" :rules="[
                {
                  message: '时间占比总和不能超过1',
                  validator: validateSumRule,
                  trigger: ['blur'],
                },
              ]">
              <div class="p_employee_btn">
                <el-input class="p_employee_num" v-model.trim="item.strTimepro" size="small" type="number" placeholder="" clearable></el-input>
                <i class="el-icon-circle-plus icon01" @click="addPost(item)"></i>
                <i v-if="index != 0" class="el-icon-delete-solid icon02" @click="dltPost(item, index)"></i>
              </div>
            </el-form-item>
          </div>
        </el-form>
        <!-- <div class="p_employee_form p_employee_form01" v-for="(item,index) in postList" :key="index+'p'">
                    <div class="p_employee_item">
                        <p class="emp_txt">工作岗位</p>
                        <div class="emp_form">
                            <el-input v-model.trim="item.strWorkJob" size="small" placeholder="请输入工作岗位" clearable></el-input>
                        </div>
                    </div>
            </div> -->
        <div class="p_employee_list">
          <p class="r_edit_title">操作权限</p>
          <div class="p_employee_form">
            <div class="p_employee_item">
              <p class="emp_txt">关联角色</p>
              <div class="emp_dtl_box">
                <span class="txts01">{{ associatedRole }}</span>
              </div>
            </div>
          </div>
          <div class="p_employee_form">
            <div class="p_employee_item">
              <p class="emp_txt">特别授权</p>
              <div class="emp_dtl_box">
                <p class="emp_dtls" @click="dltHandle">明细</p>
              </div>
            </div>
          </div>
          <div class="p_employee_form">
            <div class="p_employee_item">
              <p class="emp_txt"></p>
              <div class="emp_dtl_box">
                <el-button @click="backHandle">取消</el-button>
                <el-button :loading="btnloading" type="primary" @click="submitForm">保存</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="明细" :visible.sync="specialAuthVisible" width="700px">
      <el-form :model="specialAuthForm" ref="authform" label-width="95px">
        <el-form-item label="特别授权:">
          <div class="treeBox" v-loading="loading">
            <el-tree ref="tree" node-key="powercode" show-checkbox :data="allPowerList" :props="defaultProps" highlight-current :default-expanded-keys="[
                '1c895257-a000-d000-b000-adb6df000001',
                '1c895257-a000-d000-b001-adb6df000001',
              ]" :expand-on-click-node="false" @check-change="handleNodeClick">
              <span class="custom-tree-node" slot-scope="{ node, data }">
                <!-- 一级菜单图标 -->
                <span v-if="data.strbanded == 1" class="el-icon-folder-opened"></span>
                <!-- 二级菜单图标 -->
                <span v-else-if="data.strbanded == 2 && !isNull(data.children)" class="el-icon-folder-opened"></span>
                <span v-else-if="data.strbanded == 2 && isNull(data.children)" class="el-icon-folder"></span>
                <!-- 按钮图标 -->
                <span v-else-if="data.strbanded == 4" class="el-icon-setting"></span>
                <span v-else class="el-icon-folder" style="margin-right: 3px"></span>
                <span>{{ node.label }}</span>
              </span>
            </el-tree>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button size="small" @click="specialAuthVisible = false"
          >取消</el-button
        > -->
        <el-button size="small" type="primary" @click="confirmSave">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import xz from "@/common";
  import moment, { duration } from "moment";
  export default {
    name: "updatePost",
    data() {
      var validatecard = (rule, value, callback) => {
        if (value.length != 18) {
          callback(new Error("身份证号码格式不正确"));
        } else {
          let idcode = value;
          let weight_factor = [
            7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2,
          ];
          let check_code = [
            "1",
            "0",
            "X",
            "9",
            "8",
            "7",
            "6",
            "5",
            "4",
            "3",
            "2",
          ];
          let code = idcode + "";
          let last = idcode[17].toUpperCase(); //最后一个
          let seventeen = code.substring(0, 17);
          // ISO 7064:1983.MOD 11-2
          // 判断最后一位校验码是否正确
          let arr = seventeen.split("");
          let len = arr.length;
          let num = 0;
          for (let i = 0; i < len; i++) {
            num = num + arr[i] * weight_factor[i];
          }
          // 获取余数
          var resisue = num % 11;
          var last_no = check_code[resisue];
          // 格式的正则
          // 正则思路
          var idcard_patter =
            /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
          // 判断格式是否正确
          var format = idcard_patter.test(idcode);
          if (last === last_no && format == true) {
            callback();
          } else {
            callback(new Error("身份证号码格式不正确"));
          }
        }
      };
      var validatename = (rule, value, callback) => {
        let that = this;
        if (
          that.isNull(that.ruleForm.userInfo.mainuserid) &&
          (that.isEdit != "true") && (that.btnType != 'save')
        ) {
          this.isPhone = false;
          this.checkHandle("", value, (res) => {
            // console.log(res);
            if (res) {
              callback();
            } else {
              callback(new Error("员工姓名重复"));
            }
          });
        } else {
          callback();
        }
      };
      var validatephone = (rule, value, callback) => {
        let that = this;
        let phoneReg =
          /^(10[0-9]|11[0-9]|12[0-9]|13[0-9]|14[0-9]|15[0-9]|16[0-9]|17[0-9]|18[0-9]|19[0-9])\d{8}$/i;
        if (phoneReg.test(value)) {
          //校验通过
          // console.log('1111',that.btnType);
          if (
            that.isNull(that.ruleForm.userInfo.mainuserid) &&
            that.isEdit != "true" && (that.btnType != 'save')
          ) {
            this.checkHandle("", value, (res) => {
              // console.log('validatePhone',res)
              if (res) {
                callback();
              } else {
                //手机号已存在
                callback(false);
              }
            });
          } else {
            callback();
          }
        } else {
          callback(new Error("请输入正确的手机号"));
        }
      };
      var validatetimeSum = (rule, value, callback) => {
        let that = this;
        if (value > 1) {
          callback(new Error("时间占比不能超过1"));
        } else {
          let sum = 0;
          if (that.ruleForm.postList.length > 0) {
            for (let index = 0; index < that.ruleForm.postList.length; index++) {
              let element = that.ruleForm.postList[index];
              sum += Number(element.strTimepro);
            }
          }
          // console.log(sum);
          if (sum > 1) {
            callback(new Error("时间占比总和超过1"));
          } else {
            callback();
          }
        }
      };
      return {
        btnType: "add",
        isPhone: true,
        isEdit: "false",
        // 编辑人员的id
        editUserId: "",
        // 数组用来存储所有表单的 ref 值
        formRefs: ["empForm1", "empForm2"],
        validateSumRule: validatetimeSum,
        specialAuthVisible: false,
        // 所有权限列表
        allPowerList: [],
        defaultProps: {
          //组件必须的参数，children和label是组件固定结构，若绑定的数据名字不同，直接赋值即可
          children: "children",
          label: "powername",
        },
        specialAuthForm: {
          checkPower: [],
        },
        // 选择的节点(不包含父节点)
        checkedList: [],
        // 传给后台的选中的节点(包含父节点)
        powerList: [],
        //取权限列表参数
        powerQuery: {
          roletype: "", // 根据角色传
          stationid: "", //根据岗位
          roleuserid: "", // 根据员工id(三个都不传为所有菜单 按钮权限)
        },
        // 关联角色
        associatedRole: "",
        //新增/编辑员工
        ruleForm: {
          userInfo: {
            mainuserid: "",
            newuserid: "", //用户id
            userTel: "", //手机号
            userName: "", //姓名
            userNumber: "", //编号（新增不用传）
            stridcard: "", //身份证
            strJobfunclabel: "", //岗位职能标签（传id）
            strJobfunclabel1: "",
            strJobfunclabel2: "",
            strJobfunclabel3: "",
            strTimepro: "", //时间占比
            strTimepro1: "",
            strTimepro2: "",
            strTimepro3: "",
            strtopuserid: "", //上级领导 必传
            strtopuserid1: "", //上级领导1
            strtopuserid2: "",
            strtopuserid3: "",
            strtopuserid4: "",
            strWorkJob: "", //工作岗位
            strWorkJob1: "",
            strWorkJob2: "",
            strWorkJob3: "",
            strWorkState: "在职", //在离职
            StrIspartner: "否", //是否合伙人
            dtEntryDate: "", //入职时间
            appleTel: '', //招聘电话
            rolelabel: "", //角色标签
            dtQuitDate: "1900-01-01", //离职时间（没有传1900-01-01）
            struserdist: "", //区分
            userPwd: "", //密码
            userlabelid: "", //员工类型id
            userlabelname: "", //员工标签名称
            Strorgancode: "", //部门code
            organcodeVal: [],
            Strstation: "", //岗位id
            StrSecLevel: "", //安全级别
            StrRank: "", //职级
          },
          postList: [{
            strWorkJob: "",
            strJobfunclabel: "",
            strtopuserid: "",
            strTimepro: "",
          }, ],
        },
        // 数组用来存储所有表单的 ref 值
        formRefs: ["empForm1", "empForm2"],
        emprules1: {
          "userInfo.userName": [{
              required: true,
              message: "请输入员工姓名",
              trigger: "blur",
            },
            {
              message: "员工姓名重复",
              validator: validatename,
              trigger: ["blur"],
            },
          ],
          "userInfo.stridcard": [{
              required: true,
              message: "请输入身份证号码",
              trigger: "blur",
            },
            {
              message: "请输入正确的身份证号码",
              validator: validatecard,
              trigger: ["blur"],
            },
          ],
          "userInfo.userTel": [{
              required: true,
              message: "请输入手机号码",
              trigger: "blur",
            },
            {
              message: "手机号码不正确或手机号已存在",
              validator: validatephone,
              trigger: ["blur"],
            },
          ],
          "userInfo.struserdist": [{
            required: true,
            message: "请选择员工区分",
            trigger: "change",
          }, ],
          "userInfo.dtEntryDate": [{
            required: true,
            message: "请选择入职时间",
            trigger: "change",
          }, ],
        },
        emprules2: {
          "userInfo.organcodeVal": [{
            type: "array",
            required: true,
            message: "请选择部门",
            trigger: "change",
          }, ],
          "userInfo.Strstation": [{
            required: true,
            message: "请选择岗位",
            trigger: "change"
          }, ],
          "userInfo.strtopuserid": [{
            required: true,
            message: "请选择上级主管",
            trigger: "change"
          }, ],
        },
        // 岗位列表
        stationList: [],
        // 员工区分
        typeList: [{
            name: "J",
          },
          {
            name: "B",
          },
          {
            name: "C",
          },
          {
            name: "L",
          },
        ],
        //
        // 基础数据参数  员工类型
        baseQuery: {
          currpage: 1,
          perpage: 100000,
          Parentname: "userlabel",
        },
        // 用户列表参数
        memberQuery: {
          currpage: 1,
          perpage: 10000000,
          keyword: "",
          strWorkState: "在职",
          strstation: "",
          strorgancode: "",
        },
        // 职级
        rankList: [],
        // 安全级别
        securityList: [],
        // 上级主管
        userList: [],
        // 职能标签
        jobFunList: [],
        // 员工类型
        baseInfoList: [],
        rules: {
          name: [{
            required: true,
            message: "请输入岗位名称",
            trigger: "blur"
          }],
        },
        tableHeight: 0,
        tableLoading: false,
        loading: false,
        tableData: [],
        // 部门列表
        departmentList: [],
        // 详情参数
        dtlQuery: {
          mainuserid: "",
          useridr: "",
        },
        // 未修改岗位时默认的选中的所有code
        defaultPowerList: [],
        btnloading: false,
        // 是否有修改权限
        isHasChange: '',
        // 编辑时默认选的岗位
        editDefaultPost: '',
        // 员工编号数字
        memNum: '',
        // 改变岗位时默认的权限数据
        defaultChangePostData: []
      };
    },
    created() {
      if (this.$route.query.isEdit == "true") {
        this.isEdit = this.$route.query.isEdit;
        this.editUserId = this.$route.query.id;
        this.dtlQuery.useridr = this.$route.query.id;
        this.dtlQuery.mainuserid = this.$route.query.mainuserid;
        this.getMemberDtl();
      } else {
        this.ruleForm.userInfo.Strorgancode = this.$route.query.strorgancode
        // 获取部门列表
        this.getDepartData();
      }
      // 基础数据
      this.getBaseInfo("userlabel");
      this.getBaseInfo("StrSecLevel");
      this.getBaseInfo("StrRank");
      // 人员列表
      this.getManagerList();
      // 岗位列表
      this.getPostList();
      this.getTreestr();
    },
    methods: {
      // 添加岗位
      addPost() {
        if (this.ruleForm.postList.length < 4) {
          this.ruleForm.postList.push({
            strWorkJob: "",
            strJobfunclabel: "",
            strtopuserid: "",
            strTimepro: "",
          });
        } else {
          this.$message({
            type: "warning",
            message: "添加的总数量不能超过四个",
            center: true,
            duration: 2000,
          });
        }
      },
      // 修改员工区分
      distChange(val) {
        // console.log('val',val);
        if (this.$route.query.isEdit == "true") {
          this.ruleForm.userInfo.userNumber = val + this.memNum + '';
          // console.log('val',this.ruleForm.userInfo.userNumber);
        }
      },
      // 删除岗位
      dltPost(item, index) {
        this.ruleForm.postList.splice(index, 1);
      },
      // 查看明细
      dltHandle() {
        let that = this
        this.specialAuthVisible = true;
        this.checkedList = [];
        that.$nextTick(() => {
          // 获取默认所有选中的节点--不包含父节点
          that.powerList.forEach((f) => {
            //为了解决父级没有全选中（只选中某个子级）但是数据存在父级id然后回显选中问题
            if (
              !that.$refs.tree.getNode(f).childNodes ||
              !that.$refs.tree.getNode(f).childNodes.length
            ) {
              that.checkedList.push(f);
            }
          });
          that.$refs.tree.setCheckedKeys(that.checkedList);
        });
      },
      // 授权--节点选中状态发生变化时的回调
      handleNodeClick(data, checked, indeterminate) {
        // console.log('handleNodeClick',data)
        this.powerList = [];
        let checkKeys = this.$refs.tree.getCheckedKeys();
        let checkHAlfKeys = this.$refs.tree.getHalfCheckedKeys();
        // console.log('res',checkKeys,checkHAlfKeys)
        this.powerList = checkKeys.concat(checkHAlfKeys);
        // console.log('res',this.powerList)
      },
      // 确定授权
      confirmSave() {
        this.specialAuthVisible = false;
      },
      // 选择关联主账号
      mainChange(val) {
        let obj = {};
        let that = this;
        if (!this.isNull(val)) {
          obj = that.userList.find((item) => {
            return item.Userid === val;
          });
          // console.log('000',obj)
          that.ruleForm.userInfo.userName = obj.Username;
          that.ruleForm.userInfo.userTel = obj.Strmobile;
          that.ruleForm.userInfo.stridcard = obj.Stridcard;
          // 员工区分
          that.ruleForm.userInfo.struserdist = obj.UserNumber.substring(0, 1);
          // 员工类型
          that.ruleForm.userInfo.userlabelid = obj.Userlabelid;
          // 入职时间
          that.ruleForm.userInfo.dtEntryDate = obj.DtEntryDate;
        } else {
          that.ruleForm.userInfo.userName = "";
          that.ruleForm.userInfo.userTel = "";
          that.ruleForm.userInfo.stridcard = "";
          // 员工区分
          that.ruleForm.userInfo.struserdist = "";
          // 员工类型
          that.ruleForm.userInfo.userlabelid = "";
          // 入职时间
          that.ruleForm.userInfo.dtEntryDate = "";
        }
      },
      // 选择员工类型
      typeChange(val) {
        // console.log('类型', val)
        let obj = {};
        let that = this;
        if (!this.isNull(val)) {
          obj = that.baseInfoList.find((item) => {
            return item.Id == val;
          });
          // console.log('000',obj)
          this.ruleForm.userInfo.userlabelname = obj.Name;
        } else {
          this.ruleForm.userInfo.userlabelname = "";
        }
      },
      // 保存
      submitForm() {
        let that = this;
        this.btnType = "save";
        // 标记所有表单是否通过校验的变量
        let isValid = true;
        const form1Valid = this.$refs.empForm1.validate();
        const form2Valid = this.$refs.empForm2.validate();
        // 遍历表单数组，依次对每个表单进行校验
        that.formRefs.forEach((ref) => {
          that.$refs[ref].validate((valid) => {
            if (!valid) {
              isValid = false;
            }
          });
        });
        // console.log("sss", isValid);
        // 如果所有表单都校验通过，执行提交操作
        if (isValid) {
          that.btnloading = true
          // 执行提交操作
          that.ruleForm.userInfo.strJobfunclabel = !that.isNull(
              that.ruleForm.postList
            ) ?
            that.ruleForm.postList[0].strJobfunclabel :
            "无";
          that.ruleForm.userInfo.strTimepro = !that.isNull(that.ruleForm.postList) ?
            that.ruleForm.postList[0].strTimepro :
            "";
          that.ruleForm.userInfo.strWorkJob = !that.isNull(that.ruleForm.postList) ?
            that.ruleForm.postList[0].strWorkJob :
            "";
          that.ruleForm.userInfo.strtopuserid1 = !that.isNull(
              that.ruleForm.postList
            ) ?
            that.ruleForm.postList[0].strtopuserid :
            "";

          that.ruleForm.userInfo.strJobfunclabel1 = !that.isNull(that.ruleForm.postList) &&
            that.ruleForm.postList.length > 1 ?
            that.ruleForm.postList[1].strJobfunclabel :
            "无";
          that.ruleForm.userInfo.strTimepro1 = !that.isNull(that.ruleForm.postList) &&
            that.ruleForm.postList.length > 1 ?
            that.ruleForm.postList[1].strTimepro :
            "";
          that.ruleForm.userInfo.strWorkJob1 = !that.isNull(that.ruleForm.postList) &&
            that.ruleForm.postList.length > 1 ?
            that.ruleForm.postList[1].strWorkJob :
            "";
          that.ruleForm.userInfo.strtopuserid2 = !that.isNull(that.ruleForm.postList) &&
            that.ruleForm.postList.length > 1 ?
            that.ruleForm.postList[1].strtopuserid :
            "";

          that.ruleForm.userInfo.strJobfunclabel2 = !that.isNull(that.ruleForm.postList) &&
            that.ruleForm.postList.length > 2 ?
            that.ruleForm.postList[2].strJobfunclabel :
            "无";
          that.ruleForm.userInfo.strTimepro2 = !that.isNull(that.ruleForm.postList) &&
            that.ruleForm.postList.length > 2 ?
            that.ruleForm.postList[2].strTimepro :
            "";
          that.ruleForm.userInfo.strWorkJob2 = !that.isNull(that.ruleForm.postList) &&
            that.ruleForm.postList.length > 2 ?
            that.ruleForm.postList[2].strWorkJob :
            "";
          that.ruleForm.userInfo.strtopuserid3 = !that.isNull(that.ruleForm.postList) &&
            that.ruleForm.postList.length > 2 ?
            that.ruleForm.postList[2].strtopuserid :
            "";

          that.ruleForm.userInfo.strJobfunclabel3 = !that.isNull(that.ruleForm.postList) &&
            that.ruleForm.postList.length > 3 ?
            that.ruleForm.postList[3].strJobfunclabel :
            "无";
          that.ruleForm.userInfo.strTimepro3 = !that.isNull(that.ruleForm.postList) &&
            that.ruleForm.postList.length > 3 ?
            that.ruleForm.postList[3].strTimepro :
            "";
          that.ruleForm.userInfo.strWorkJob3 = !that.isNull(that.ruleForm.postList) &&
            that.ruleForm.postList.length > 3 ?
            that.ruleForm.postList[3].strWorkJob :
            "";
          that.ruleForm.userInfo.strtopuserid4 = !that.isNull(that.ruleForm.postList) &&
            that.ruleForm.postList.length > 3 ?
            that.ruleForm.postList[3].strtopuserid :
            "";
          // 密码
          if (this.isEdit == "false") {
            let idcode = this.ruleForm.userInfo.stridcard.substring(
              this.ruleForm.userInfo.stridcard.length - 6
            );
            this.ruleForm.userInfo.userPwd = idcode + "##";
          } else {
            this.ruleForm.userInfo.userPwd = "";
          }
          let arrlength = that.powerList.length;
          // 比较是否修改了权限
          let defaullength = that.defaultChangePostData.length;
          let defaultList = JSON.parse(JSON.stringify(that.defaultPowerList)) //拷贝岗位没改变时的默认权限
          let powerCopy = JSON.parse(JSON.stringify(that.powerList)) //拷贝选中的权限
          let powerChangeCopy = JSON.parse(JSON.stringify(that.defaultChangePostData)) //拷贝对应权限
          let finaldata;
          let isEqual = defaultList.filter(item => powerCopy.indexOf(item) == -1);
          // 现在选中的岗位权限与此岗位默认权限对比
          let ischangeData = powerChangeCopy.filter(item => powerCopy.indexOf(item) == -1);
          // console.log(88888,isEqual,arrlength == defaullength,that.isNull(isEqual))
          if (that.isEdit == 'true') { // 编辑人员时
            if (this.isHasChange == 'has') { // 此账号有特殊授权
              if (that.editDefaultPost != that.ruleForm.userInfo.Strstation) { // 改变了岗位
                if (that.isNull(ischangeData) && (arrlength == defaullength)) { // 权限无改变
                  finaldata = ''
                } else {
                  finaldata = that.powerList.toString();
                }
              } else {
                finaldata = that.powerList.toString();
              }
            } else { // 无特殊授权
              if (that.editDefaultPost != that.ruleForm.userInfo.Strstation) { // 改变了岗位
                if (that.isNull(ischangeData) && (arrlength == defaullength)) { // 权限无改变
                  finaldata = ''
                } else {
                  finaldata = that.powerList.toString();
                }
              } else {
                if (that.isNull(isEqual) && (arrlength == defaultList.length)) { // 权限无改变
                  finaldata = ''
                } else {
                  finaldata = that.powerList.toString();
                }
              }
            }
          } else {
            let change1 = defaultList.filter(item => powerCopy.indexOf(item) == -1);
            if (change1 && (defaultList.length == that.powerList.length)) { // 权限无改变
              finaldata = ''
            } else {
              finaldata = that.powerList.toString();
            }
          }
          // console.log("sss",that.ruleForm,"fff",finaldata);
          //统一提交表单
          xz.updateauthJbUserInfo(that.ruleForm.userInfo, finaldata).then(
            (res) => {
              // console.log('角色', res)
              if (res.status == "ok") {
                that.$message({
                  type: "success",
                  message: "操作成功！",
                  center: true,
                  duration: 2000,
                });
                that.$router.push({
                  path: "/departMember",
                  query: {
                    active: "2",
                    memGancode: that.ruleForm.userInfo.Strorgancode
                  },
                });
              } else {
                that.$message({
                  type: "error",
                  message: "操作失败，请稍后再试！",
                  center: true,
                  duration: 2000,
                });
              }
              that.btnloading = false
              this.btnType = "add";
            }
          );
        }
      },
      // 选择部门
      departChange(val) {
        // console.log('ff',val)
        // const checkedNode= this.$refs["cascader"].panel.getNodeByValue(val);
        // console.log( 'www',checkedNode);
        // if(!this.isNull(checkedNode)){
        //   // this.depForm.strorganname = checkedNode00[0].pathLabels.join('/')
        // }
        if (!this.isNull(val)) {
          this.ruleForm.userInfo.Strorgancode = val[val.length - 1];
        } else {
          this.ruleForm.userInfo.Strorgancode = "";
        }
      },
      // 选择岗位
      stationChange(val) {
        // console.log('ff',val)
        let obj = {};
        let that = this;
        if (!this.isNull(val)) {
          obj = that.stationList.find((item) => {
            return item.Stationid === val;
          });
          // console.log('000',obj)
          this.associatedRole = obj.Strroletypesname;
          if (that.isEdit == 'true' && (!that.isNull(that.$route.query.id))) { // 编辑跳转过来
            if (that.isHasChange == 'no' || (that.editDefaultPost != that.ruleForm.userInfo.Strstation)) { // 传用户id，没有返回数据，传岗位或者岗位有改变走接口
              that.powerQuery.stationid = val;
              that.powerQuery.roleuserid = "";
              that.powerQuery.roletype = "";
              that.getPowerList('pass', 'change');
            } else { // 人员编辑先传用户id，有返回数据
              that.powerQuery.stationid = '';
              that.powerQuery.roleuserid = that.$route.query.id;
              that.powerQuery.roletype = "";
              that.getPowerList('pass');
            }
          } else { // 新增人员时
            that.powerQuery.stationid = val;
            that.powerQuery.roleuserid = "";
            that.powerQuery.roletype = "";
            that.getPowerList('dtl');
          }
        } else {
          this.associatedRole = "";
          this.powerQuery.stationid = "";
          this.powerQuery.roleuserid = '';
        }
      },
      // 人员详情
      getMemberDtl() {
        let that = this;
        this.tableLoading = true;
        xz.getauthJbUserDetail(this.dtlQuery).then((res) => {
          // console.log('res',res)
          if (res.status == "ok") {
            let resmsg = res.msg;
            // let inforoledist = res.inforoledist
            // let inforolediststring = JSON.stringify(res.inforoledist);
            if (res.StrIsSpeAuth!= '1') { //没有返回数据
              this.isHasChange = 'no'
              // 获取权限明细
              that.powerQuery = {
                roletype: "", // 根据角色传
                stationid: resmsg.Strstation, //根据岗位
                roleuserid: '' // 根据员工id(三个都不传为所有菜单 按钮权限)
              };
            } else {
              this.isHasChange = 'has'
              // 获取权限明细
              that.powerQuery = {
                roletype: "", // 根据角色传
                stationid: "", //根据岗位
                roleuserid: resmsg.Userid // 根据员工id(三个都不传为所有菜单 按钮权限)
              };
            }
            console.log('111',this.isHasChange)
            this.editDefaultPost = resmsg.Strstation
            this.ruleForm.userInfo.mainuserid = resmsg.Mainuserid;
            this.ruleForm.userInfo.newuserid = resmsg.Userid;
            this.ruleForm.userInfo.userTel = resmsg.Strmobile;
            this.ruleForm.userInfo.userName = resmsg.Username;
            this.ruleForm.userInfo.appleTel = resmsg.AppleTel;
            this.ruleForm.userInfo.userNumber = resmsg.UserNumber;
            this.ruleForm.userInfo.stridcard = resmsg.Stridcard;
            this.ruleForm.userInfo.strJobfunclabel = resmsg.StrJobfunclabel;
            this.ruleForm.userInfo.strJobfunclabel1 = resmsg.StrJobfunclabel1;
            this.ruleForm.userInfo.strJobfunclabel2 = resmsg.StrJobfunclabel2;
            this.ruleForm.userInfo.strJobfunclabel3 = resmsg.StrJobfunclabel3;
            this.ruleForm.userInfo.strTimepro = resmsg.StrTimepro;
            this.ruleForm.userInfo.strTimepro1 = resmsg.StrTimepro1;
            this.ruleForm.userInfo.strTimepro2 = resmsg.StrTimepro2;
            this.ruleForm.userInfo.strTimepro3 = resmsg.StrTimepro3;
            this.ruleForm.userInfo.strtopuserid = resmsg.Strtopuserid;
            this.ruleForm.userInfo.strtopuserid1 = resmsg.Strtopuserid1;
            this.ruleForm.userInfo.strtopuserid2 = resmsg.Strtopuserid2;
            this.ruleForm.userInfo.strtopuserid3 = resmsg.Strtopuserid3;
            this.ruleForm.userInfo.strtopuserid4 = resmsg.Strtopuserid4;
            this.ruleForm.userInfo.strWorkJob = resmsg.StrWorkJob;
            this.ruleForm.userInfo.strWorkJob1 = resmsg.StrWorkJob1;
            this.ruleForm.userInfo.strWorkJob2 = resmsg.StrWorkJob2;
            this.ruleForm.userInfo.strWorkJob3 = resmsg.StrWorkJob3;
            this.ruleForm.userInfo.strWorkState = resmsg.StrWorkState;
            this.ruleForm.userInfo.StrIspartner = resmsg.StrIspartner;
            this.ruleForm.userInfo.dtEntryDate = resmsg.DtEntryDate;
            this.ruleForm.userInfo.rolelabel = resmsg.Rolelabel;
            this.ruleForm.userInfo.dtQuitDate = resmsg.DtQuitDate;
            this.ruleForm.userInfo.struserdist = resmsg.UserNumber.substring(0, 1);
            this.memNum = !this.isNull(resmsg.UserNumber) ? resmsg.UserNumber.split(this.ruleForm.userInfo.struserdist)[1] : ''
            this.ruleForm.userInfo.userPwd = "";
            this.ruleForm.userInfo.userlabelid = resmsg.Userlabelid;
            this.ruleForm.userInfo.userlabelname = resmsg.Userlabelname;
            this.ruleForm.userInfo.Strorgancode = resmsg.Strorgancode;
            this.ruleForm.userInfo.Strstation = resmsg.Strstation;
            this.ruleForm.userInfo.StrSecLevel = resmsg.StrSecLevel;
            this.ruleForm.userInfo.StrRank = resmsg.StrRank;
            this.getDepartData();
            if (resmsg.Strroletypesname.indexOf("系统出错") > -1) {
              this.associatedRole = "";
            } else {
              this.associatedRole = resmsg.Strroletypesname;
            }
            this.ruleForm.postList = [{
                strWorkJob: resmsg.StrWorkJob,
                strJobfunclabel: resmsg.StrJobfunclabel,
                strtopuserid: resmsg.Strtopuserid1,
                strTimepro: resmsg.StrTimepro,
              },
              {
                strWorkJob: resmsg.StrWorkJob1,
                strJobfunclabel: resmsg.StrJobfunclabel1,
                strtopuserid: resmsg.Strtopuserid2,
                strTimepro: resmsg.StrTimepro1,
              },
              {
                strWorkJob: resmsg.StrWorkJob2,
                strJobfunclabel: resmsg.StrJobfunclabel2,
                strtopuserid: resmsg.Strtopuserid3,
                strTimepro: resmsg.StrTimepro2,
              },
              {
                strWorkJob: resmsg.StrWorkJob3,
                strJobfunclabel: resmsg.StrJobfunclabel3,
                strtopuserid: resmsg.Strtopuserid4,
                strTimepro: resmsg.StrTimepro3,
              },
            ];
            // 去除非空对象
            let filteredArr = this.ruleForm.postList.filter((obj) => {
              return !this.isNull(obj.strWorkJob);
            });
            if (that.isNull(filteredArr)) {
              this.ruleForm.postList = [{
                strWorkJob: "",
                strJobfunclabel: "",
                strtopuserid: "",
                strTimepro: "",
              }, ];
            } else {
              this.ruleForm.postList = filteredArr;
            }
            this.getPowerList("dtl");
          } else {
            console.log("获取详情出错");
          }
          this.tableLoading = false;
        });
      },
      // 上级主管
      getManagerList() {
        xz.getauthUserInfoByorgancode(this.memberQuery).then((res) => {
          if (res.status == "ok") {
            this.userList = res.msg;
          } else {
            this.userList = [];
          }
        });
      },
      // 遍历递归--获取选中的节点
      generaNode(ele, data) {
        let that = this;
        data.forEach((item) => {
          if (item.isused == "1") {
            ele.push(item.powercode);
          }
          if (!that.isNull(item.children)) {
            that.generaNode(ele, item.children);
          }
        });
      },
      // 获取配置权限菜单列表(通用)
      getPowerList(type, state) {
        this.loading = true;
        this.checkedList = [];
        this.powerList = [];
        let that = this;
        xz.baLLGetauthPowerInf(this.powerQuery).then((res) => {
          // console.log('权限菜单', res)
          if (res.status == "ok") {
            that.allPowerList = res.msg.parent;
            let allList = res.msg.parent;
            // 回显默认所有选中的节点--包含父节点
            that.generaNode(that.powerList, allList);
            if (this.$refs.tree && (type == 'pass')) {
              // console.log(1111,this.powerList)
              that.$nextTick(() => {
                // 获取默认所有选中的节点--不包含父节点
                that.powerList.forEach((f) => {
                  //为了解决父级没有全选中（只选中某个子级）但是数据存在父级id然后回显选中问题
                  if (
                    !that.$refs.tree.getNode(f).childNodes ||
                    !that.$refs.tree.getNode(f).childNodes.length
                  ) {
                    that.checkedList.push(f);
                  }
                });
                that.$refs.tree.setCheckedKeys(that.checkedList);
              });
            }
            // 默认选中未修改的code
            if (type == 'dtl') {
              that.generaNode(that.defaultPowerList, allList);
            }
            // 获取岗位改变时的默认岗位权限
            if (state == 'change') {
              that.generaNode(that.defaultChangePostData, allList);
            }
            // console.log('checkedList', that.powerList)
          } else {
            that.allPowerList = [];
          }
          that.loading = false;
        });
      },
      // 取消
      backHandle() {
        this.$router.push({
          path: "/departMember",
        });
      },
      //校验姓名/手机号码
      checkHandle(userid, chkval, callback) {
        if (chkval.length > 0) {
          // if (this.ruleForm.userInfo.userTel.length > 10 || this.isPhone == false) {
          xz.checkJbUserInfo(userid, "b", chkval).then((res) => {
            if (res.status == "ok") {
              callback(true);
            } else {
              callback(false);
            }
          });
          // }
        }
      },
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == "NaN"
        );
      },
      //获取岗位职能标签
      getTreestr() {
        let data = {
          currpage: 1,
          perpage: 100,
          strIsDisable: "1",
          keyword: "",
        };
        xz.getTreestr("JB_base_Jobfunclabel", data).then((res) => {
          if (res) {
            this.jobFunList = res.msg.parent;
          } else {
            this.jobFunList = [];
          }
        });
      },
      // 获取部门列表
      getDepartData() {
        let query = {
          strIsDisable: "1",
        };
        let that = this;
        xz.getorganstr1("", "", query).then((res) => {
          // console.log('gg',res)
          if (res && !this.isNull(res.parent)) {
            that.departmentList = res.parent[0].children;
            if ((that.$route.query.isEdit == "true") || (!that.isNull(that.$route.query.strorgancode))) {
              that.$nextTick(() => {
                let checkedNode = that.$refs["cascader"].panel.getNodeByValue(
                  this.ruleForm.userInfo.Strorgancode
                );
                // console.log( 'www',checkedNode);
                if (!that.isNull(checkedNode)) {
                  let paths = checkedNode.path;
                  that.ruleForm.userInfo.organcodeVal = paths;
                } else {
                  that.ruleForm.userInfo.organcodeVal = [];
                }
              });
            }
          } else {
            this.departmentList = [];
          }
        });
      },
      // 获取岗位列表
      getPostList() {
        let dataQuery = {
          keyword: "", // 角色名称
          perpage: 1000000,
          currpage: 1,
        };
        xz.bgetStationauthList(dataQuery).then((res) => {
          // console.log('岗位', res)
          if (res.status == "ok") {
            let result = res.msg;
            this.stationList = result.filter((num) => {
              return num.Stationid != "c888ddab-098a-4a41-bb95-38cadminuser";
            });
          } else {
            this.stationList = [];
          }
        });
      },
      // 获取基础数据(用户类型等)
      getBaseInfo(type) {
        this.baseQuery.Parentname = type;
        xz.getBasicDatas(this.baseQuery).then((res) => {
          // console.log('55',res)
          if (res.status == "ok") {
            if (type == "userlabel") {
              this.baseInfoList = res.msg;
            }
            if (type == "StrSecLevel") {
              this.securityList = res.msg;
            }
            if (type == "StrRank") {
              this.rankList = res.msg;
            }
          } else {
            if (type == "userlabel") {
              this.baseInfoList = [];
            }
            if (type == "StrSecLevel") {
              this.securityList = res.msg;
            }
            if (type == "StrRank") {
              this.rankList = res.msg;
            }
          }
        });
      },
      changePhone(val) {
        if (val.length == 11) {
          let str = `CheckNumberDuplication?Mobile=${val}&userid=${this.ruleForm.userInfo.newuserid}`
          xz.BasicGetFun(str).then(res => {
            if (res.status == 'ok') {

            } else {
              this.$message({
                message:`当前手机号 ${this.ruleForm.userInfo.userTel} 已被注册！`,
                type:'error',
                duration:5000
              })
              this.ruleForm.userInfo.userTel = '';
            }
          })
        }
      }
    },
  };
</script>
<style scoped>
  .treeBox {
    /* max-height: 700px; */
    min-height: 30px;
    /* overflow-y: auto; */
    border: 1px solid #dcdfe6;
    box-sizing: border-box;
  }

  .note_icon {
    color: #f56c6c;
    margin-right: 4px;
  }

  .r_edit_title {
    font-size: 16px;
    line-height: 26px;
    font-weight: bold;
    color: #000;
    border-bottom: 1px solid #dcdfe6;
  }

  .emp_form {
    width: 200px;
  }

  .emp_form_num.emp_form {
    width: 130px;
  }

  .p_employee_top {
    width: 100%;
  }

  .emp_dtl_box {
    padding-left: 10px;
    flex: 1;
  }

  .icon01 {
    color: #19bd92;
    font-size: 28px;
    cursor: pointer;
  }

  .emp_dtls {
    cursor: pointer;
    color: #19bd92;
    font-size: 14px;
  }

  .txts01 {
    font-size: 14px;
  }

  .icon02 {
    color: #e6a23c;
    font-size: 28px;
    cursor: pointer;
    margin-left: 10px;
  }

  .p_employee_btn {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .p_employee_item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    /* margin-right: 3px; */
  }

  .p_employee_form.p_employee_form01 {
    margin-top: 0;
  }

  .p_employee_form {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
  }

  .emp_txt {
    width: 90px;
    text-align: right;
    font-size: 14px;
    color: #606266;
    line-height: 40px;
    padding: 0 6px 0 0;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }

  .p_btn_box {
    width: 100%;
    display: flex;
    justify-content: flex-end;
    padding-top: 10px;
    padding-right: 10px;
    box-sizing: border-box;
    margin-bottom: 10px;
  }

  .p_employee_box {
    background-color: #fff;
    padding: 15px 10px;
  }
</style>
<style>
  .p_employee_content .p_employee_num {
    width: 120px;
  }

  .p_employee_content .p_employee_box .el-form-item__label {
    padding: 0 5px 0 0;
  }

  .p_employee_content .p_employee_box .el-select,
  .p_employee_content .p_employee_box .el-form-item__content,
  .p_employee_content .p_employee_box .el-date-editor,
  .p_employee_content .p_employee_box .el-date-editor.el-input {
    width: 200px;
  }

  .p_employee_content .p_employee_form .el-form-item {
    margin-bottom: 16px;
  }

  .p_employee_content .p_post_form .el-input,
  .p_employee_content .p_post_form .el-textarea {
    width: 600px;
  }
</style>